import { Box, Text, Flex, Icon, Heading } from '@podiumhq/design-system';
import { useTrialsContext } from 'contexts/TrialsContextProvider';
import { AsYouType } from 'libphonenumber-js';
import { motion } from 'framer-motion';
import { useRef } from 'react';

const ProfileImagery = ({ disableAnimations = false }) => {
  const { firstName, lastName, phone, verifiedAccount } =
    useTrialsContext() || {};

  let clientCountry = useRef(null);

  const boxStyles = {
    w: '270px',
    h: '24px',
    bg: '#eeecea',
    ml: '88px',
    mt: '42px',
    borderRadius: '8px',
  };
  return (
    <motion.div
      initial={{
        y: disableAnimations ? 0 : 40,
        opacity: disableAnimations ? 1 : 0,
      }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Box bg="white" borderRadius="24px" w="470px" m="150px auto 0" p="32px">
        <Flex flexDir="row">
          <ProfilePicture
            firstName={firstName}
            lastName={lastName}
            disableAnimations={disableAnimations}
            isVerified={verifiedAccount}
          />
          <Flex flexDir="column" pl="24px">
            <Heading fontSize="2xl" fontWeight="medium">
              {firstName} {lastName}
            </Heading>
            <Text color="grey.light" fontSize="lg" fontWeight="normal" pt="8px">
              {new AsYouType(clientCountry.current || 'US').input(phone)}
            </Text>
          </Flex>
        </Flex>

        {[1, 2, 3].map((v, index) => (
          <Box key={index} {...boxStyles} />
        ))}
        <Box mb="36px" />
      </Box>
    </motion.div>
  );
};

export default ProfileImagery;

const ProfilePicture = ({
  firstName,
  lastName,
  disableAnimations,
  isVerified,
}) => {
  return (
    <Box display="grid">
      <Box
        w="64px"
        h="64px"
        bg="silver.base"
        borderRadius="16px"
        gridRow="1"
        gridColumn="1"
      />
      {firstName && (
        <motion.div
          initial={{ scale: disableAnimations ? 1 : 0 }}
          animate={{ scale: 1 }}
          style={{ gridRow: 1, gridColumn: 1 }}
        >
          <Box w="64px" h="64px" bg="orange" borderRadius="16px">
            <Heading
              textAlign="center"
              lineHeight="64px"
              fontSize="2xl"
              fontWeight="medium"
              color="white"
            >
              {firstName.charAt(0).toUpperCase()}
              {lastName.charAt(0).toUpperCase()}
            </Heading>
          </Box>
        </motion.div>
      )}
      {isVerified && (
        <>
          <motion.div
            initial={{ x: 45, y: -15, scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.2 }}
            style={{ width: 25, height: 25 }}
          >
            <Box
              w="25px"
              h="25px"
              bg="#48C78C"
              borderRadius="8px"
              outline="4px solid white"
              textAlign="center"
            >
              <Icon
                type="Check2"
                color="silver.lightest"
                boxSize="20px"
                m="0 auto"
              />
            </Box>
          </motion.div>
          <motion.div
            initial={{ width: 0, x: 78, y: -36, rotate: 160 }}
            animate={{ width: 7 }}
            transition={{ delay: 0.2 }}
          >
            <Box h="1px" bg="black.base" />
          </motion.div>
          <motion.div
            initial={{ width: 0, x: 80, y: -27 }}
            animate={{ width: 7 }}
            transition={{ delay: 0.4 }}
          >
            <Box h="1px" bg="black.base" />
          </motion.div>
          <motion.div
            initial={{ width: 0, x: 78, y: -18, rotate: 25 }}
            animate={{ width: 7 }}
            transition={{ delay: 0.6 }}
          >
            <Box h="1px" bg="black.base" />
          </motion.div>
        </>
      )}
    </Box>
  );
};
